import '../../common/css/atrRequest.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';
import moment from 'moment';
import CustomDatePicker from '../common/datepicker';
import { format } from 'date-fns';

function ATRdetail() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [detailData, setDetailData] = useState(true);

    // ATR 발권 요청 데이터
    const [prePNR, setPrePNR] = useState('');
    const [preTL, setPreTL] = useState('');
    const [preTLtime, setPreTLtime] = useState('');
    const [preFB, setPreFB] = useState('');
    const [preBCC, setPreBCC] = useState('');
    const [preAuthNum, setPreAuthNum] = useState('');
    const [preItCode, setPreITCode] = useState('');
    const [preETC, setPreETC] = useState('');
    const [preChildInfo, setPreChildInfo] = useState('');
    const [preInfantInfo, setPreInfantInfo] = useState('');
    const [preFOC, setPreFOC] = useState('');
    const [preAdultSelling, setPreAdultSelling] = useState('0');
    const [preAdultNum, setPreAdultNum] = useState('0');
    const [preAdultTax, setPreAdultTax] = useState('0');
    const [preChildSelling, setPreChildSelling] = useState('0');
    const [preChildNum, setPreChildNum] = useState('0');
    const [preChildTax, setPreChildTax] = useState('0');
    const [preInfantSelling, setPreInfantSelling] = useState('0');
    const [preInfantNum, setPreInfantNum] = useState('0');
    const [preInfantTax, setPreInfantTax] = useState('0');
    const [preFOCSelling, setPreFOCSelling] = useState('0');
    const [preFOCTax, setPreFOCTax] = useState('0');
    const [preFOCNum, setPreFOCNum] = useState('0');
    const [preTotal, setPreTotal] = useState('0');
    const [preComm, setPreComm] = useState('0');
    const [preVAT, setPreVAT] = useState('0');
    const [preCardNum, setPreCardNum] = useState('');
    const [preCardHolder, setPreCardHolder] = useState('');
    const [preCardYear, setPreCardYear] = useState(0);
    const [preCardMonth, setPreCardMonth] = useState(0);
    const [preMonthlyment, setPreMonthlyment] = useState(0);

    const [IsPaymentType, setIsPaymentType] = useState('cash');
    const [cardType, setCardType] = useState('BC');
    const [SaveBtn, setSaveBtn] = useState(true);
    const [regAgentName, setRegAgentName] = useState('');
    const [regAgentPhone, setRegAgentPhone] = useState('');
    const [regAgentId, setRegAgentId] = useState('');
    const [regAgentCode, setRegAgentCode] = useState('');
    const [regKornName, setRegKornName] = useState('');
    const [regAgentEmail, setRegAgentEmail] = useState('');

    // 달력
    const [selectedDate, setSelectedDate] = useState(new Date());

    const [status, setStatus] = useState('');

    const requestCancel = async () => {
        try {
            const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

            const seq = window.location.search.split('=')[1];
            const response = await axios.patch(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/preticket/requestcancel`,
                { seq },
                {
                    withCredentials: true,
                },
            );

            if (response.data.rowsAffected[0] === 1) {
                setModalContent('취소 요청이 완료되었습니다.');
                setModalAction(() => () => window.location.reload());
                setSaveStatus(false);
                setStatus('취소확인');
            }
        } catch (error) {
            setModalContent('취소 요청중 오류가 발생했습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    // 개발전 요청 삭제 기능
    const requestDelete = async () => {
        try {
            const seq = window.location.search.split('=')[1];
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.patch(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/preticket/requestDelete`,
                { seq },
                {
                    withCredentials: true,
                },
            );

            if (response.data.rowsAffected[0] === 1) {
                setModalContent('삭제완료 되었습니다.');
                setModalAction(() => () => window.location.href('/group/atrlist'));
                setSaveStatus(false);
            }
        } catch (error) {
            setModalContent('취소 요청중 오류가 발생했습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    const requestUpdate = async () => {
        try {
            const seq = window.location.search.split('=')[1];
            const requestStatus = status === 0 ? '요청중' : status === 1 ? '확인완료' : '';
            const data = {
                seq,
                requestStatus,
                prePNR,
                preTL,
                preTLtime,
                preFB,
                preBCC,
                preAuthNum,
                preItCode,
                preETC,
                preChildInfo,
                preInfantInfo,
                preFOC,
                preAdultSelling,
                preAdultNum,
                preAdultTax,
                preChildSelling,
                preChildNum,
                preChildTax,
                preInfantSelling,
                preInfantNum,
                preInfantTax,
                preFOCSelling,
                preFOCNum,
                preFOCTax,
                preTotal,
                preComm,
                preVAT,
                prePayment: IsPaymentType,
                preCard: IsPaymentType,
                preCardNum,
                preCardHolder,
                preCardYear,
                preCardMonth,
                preMonthlyment,
            };
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.patch(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/preticket/requestedit`,
                { data },
                {
                    withCredentials: true,
                },
            );

            if (response.data === 1) {
                setModalContent('요청이 완료되었습니다.');
                setModalAction(() => () => window.location.reload());
                setSaveStatus(false);
            }
        } catch (error) {
            setModalContent('수정 요청 중 오류가 발생했습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    const handleDateChange = (date) => {
        const dateStr = format(date, 'yyyy-MM-dd HH:mm');
        setSelectedDate(date);
        setPreTL(dateStr.split(' ')[0]);
        setPreTLtime(dateStr.split(' ')[1]);
    };

    // 1인당 금액 성인, 소아, 유아 계산기
    useEffect(() => {
        const totalAmountCalculater = () => {
            const adultSelling = preAdultSelling === '' ? 0 : parseInt(preAdultSelling);
            const adultNum = preAdultNum === '' ? 0 : parseInt(preAdultNum);
            const adultTax = preAdultTax === '' ? 0 : parseInt(preAdultTax);
            const childSelling = preChildSelling === '' ? 0 : parseInt(preChildSelling);
            const childNum = preChildNum === '' ? 0 : parseInt(preChildNum);
            const childTax = preChildTax === '' ? 0 : parseInt(preChildTax);
            const infantSelling = preInfantSelling === '' ? 0 : parseInt(preInfantSelling);
            const infantNum = preInfantNum === '' ? 0 : parseInt(preInfantNum);
            const infantTax = preInfantTax === '' ? 0 : parseInt(preInfantTax);
            const FOCSelling = preFOCSelling === '' ? 0 : parseInt(preFOCSelling);
            const FOCTax = preFOCTax === '' ? 0 : parseInt(preFOCTax);
            const FOCNum = preFOCNum === '' ? 0 : parseInt(preFOCNum);

            const totalAmount =
                (adultSelling + adultTax) * adultNum +
                (childSelling + childTax) * childNum +
                (infantSelling + infantTax) * infantNum +
                (FOCSelling + FOCTax) * FOCNum;

            setPreTotal(totalAmount.toString());
        };

        totalAmountCalculater();
    }, [
        preAdultSelling,
        preAdultNum,
        preAdultTax,
        preChildSelling,
        preChildNum,
        preChildTax,
        preInfantSelling,
        preInfantNum,
        preInfantTax,
        preFOCSelling,
        preFOCNum,
        preFOCTax,
    ]);

    // 서버통신
    useEffect(() => {
        const axiosData = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const seq = params.get('seq') ?? 1;
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }
                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/preticket/detail?seq=${seq}`,
                    {
                        withCredentials: true,
                    },
                );
                console.log(response.data);
                if (response.data.preStatus === '요청중' || response.data.preStatus === '보류') {
                    setStatus(0);
                } else if (
                    response.data.preStatus === '확인완료' ||
                    response.data.preStatus === '입금완료'
                ) {
                    setStatus(1);
                } else if (
                    response.data.preStatus === '취소요청' ||
                    response.data.preStatus === '취소확인' ||
                    response.data.preStatus === '발권완료'
                ) {
                    setStatus(99);
                }

                setPrePNR(response.data.prePNR);
                setPreTL(response.data.preTL);
                setPreTLtime(response.data.preTLtime);
                setPreFB(response.data.preFB);
                setPreBCC(response.data.preBCC);
                setPreAuthNum(response.data.preAuthNum);
                setPreITCode(response.data.preItCode);
                setPreETC(response.data.preETC);
                setPreChildInfo(response.data.preChildInfo);
                setPreInfantInfo(response.data.preInfantInfo);
                setPreFOC(response.data.preFOC);
                setPreAdultSelling(response.data.preAdultSelling);
                setPreAdultNum(response.data.preAdultNum);
                setPreAdultTax(response.data.preAdultTax);
                setPreChildSelling(response.data.preChildSelling);
                setPreChildNum(response.data.preChildNum);
                setPreChildTax(response.data.preChildTax);
                setPreInfantSelling(response.data.preInfantSelling);
                setPreInfantNum(response.data.preInfantNum);
                setPreInfantTax(response.data.preInfantTax);
                setPreFOCSelling(response.data.preFOCSelling);
                setPreFOCNum(response.data.preFOCNum);
                setPreFOCTax(response.data.preFOCTax);
                setPreTotal(response.data.preTotal);

                setDetailData(response.data);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);
            }
        };

        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    return (
        <div className='bodyContainer'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list'>
                    <div class='subp_h_home'></div>
                    <div>단체견적/발권</div>
                    <div>ATR 발권 요청</div>
                    <div>요청하기</div>
                </div>
            </div>
            <div id='contents'>
                <div className='signUpFromWrap'>
                    <div className='page_hgroup'>
                        <h2 className='title'>ATR 발권 요청</h2>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>ATR 발권 유의 사항</h4>

                        <table className='signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        ATR 발권 요청 문의
                                    </th>
                                    <td>
                                        <p className='table-padding wpal-atr-contact-info'>
                                            <span>전화: 02) 2085-8696</span>
                                            <span>|</span>
                                            <span>팩스: 02) 744-0544</span>
                                            <span>|</span>
                                            <span>세금계산서 E-mail: etax@philippineair.co.kr</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        접수 시간 및 수령 시간
                                    </th>
                                    <td>
                                        <div className='wpal-atr-innertable-padding'>
                                            <span className=' authNumberTxt'>
                                                ※ 발권 TL 당일의 발권 요청은 엄격히 금지됩니다.
                                            </span>
                                            <table className='wpal-atr-inner-table'>
                                                <thead>
                                                    <tr>
                                                        <th>사전 발권 신청 접수</th>
                                                        <th>전자세금계산서 접수</th>
                                                        <th>항공권 수령</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>09:00 ~ 12:00</td>
                                                        <td>당일 14:00 까지</td>
                                                        <td>익일 14:00 ~ 18:00</td>
                                                    </tr>
                                                </tbody>
                                                <tbody>
                                                    <tr>
                                                        <td>12:00 ~ 18:00</td>
                                                        <td>익일 09:00 ~ 12:00</td>
                                                        <td>익일 14:00 ~ 18:00</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>구비서류</th>
                                    <td>
                                        <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-header'>
                                                [현금 결제 시]
                                            </div>
                                            <div className='table-padding wpal-atr-td-content'>
                                                1) 전자세금계산서, 2) 사전발권신청서, 3) 현금입금증
                                                (입금인을 명확히 기입한 경우 입금증 없어도 무방)
                                            </div>
                                        </div>
                                        {/* <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-header'>
                                                [카드 결제 시]
                                            </div>
                                            <div className='table-padding wpal-atr-td-content'>
                                                1) 전자세금계산서, 2) 사전발권신청서, 3)
                                                UCCCF(앞/뒷면 압인, 카드 소지인 서명), 4) 카드
                                                앞/뒷면 CPY(카드 소지인의 자필서명),
                                                <br /> 5) 카드 소지인 신분증 COPY
                                            </div>
                                        </div>
                                        <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-header table-line-b'>
                                                *법인카드 사용의 경우, 1) ~ 5) 서류 외에 하기 추가
                                                서류 필요
                                            </div>
                                            <div className='table-padding wpal-atr-td-content'>
                                                a) 무기명, 미싸인 - 수령인의 재직증명서 or 명함, b)
                                                기명 - 기명된 사람의 재직증명서 or 명함
                                            </div>
                                        </div>
                                        <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-content'>
                                                ※ UCCCF로 카드 결제시에는 반드시 명단에 있는 승객의
                                                카드로만가능 / 제3자 카드로는 결제 불가능
                                            </div>
                                        </div> */}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* 단체 정보 */}
                    <div className='agentCheckWrap'>
                        <h4>ATR 발권 요청</h4>

                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        ATR 발권 신청인
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData.userInfo?.userName}
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>여행사명</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData.userInfo?.kornName}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>휴대폰번호</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData.userInfo?.userPhone}
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        티켓수령 이메일
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData.userInfo?.userEmail}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        항공사 예약번호
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.prePNR
                                            ) : status == '1' ? (
                                                detailData?.prePNR
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='pnrNumber'
                                                    value={prePNR}
                                                    onChange={(e) => setPrePNR(e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, ''))}
                                                />
                                            )}
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>발권 TL</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preTL + ' ' + detailData?.preTLtime
                                            ) : status == '1' ? (
                                                detailData?.preTL + ' ' + detailData?.preTLtime
                                            ) : (
                                                <CustomDatePicker
                                                    selectedDate={selectedDate}
                                                    onChange={handleDateChange}
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>Fare Basis</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preFB
                                            ) : status == '1' ? (
                                                detailData?.preFB
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='fareBasis'
                                                    value={preFB}
                                                    onChange={(e) => setPreFB(e.target.value)}
                                                />
                                            )}
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>BCC</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preBCC
                                            ) : status == '1' ? (
                                                detailData?.preBCC
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='bcc'
                                                    value={preBCC}
                                                    onChange={(e) => setPreBCC(e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, ''))}
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>Auth Number</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preAuthNum
                                            ) : status == '1' ? (
                                                detailData?.preAuthNum
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='authNum'
                                                    value={preAuthNum}
                                                    onChange={(e) => setPreAuthNum(e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, ''))}
                                                />
                                            )}
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>IT Code</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preItCode
                                            ) : status == '1' ? (
                                                detailData?.preItCode
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='idCode'
                                                    value={preItCode}
                                                    onChange={(e) => setPreITCode(e.target.value)}
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        요청 사항 / 비고
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preETC
                                            ) : (
                                                <textarea
                                                    className='wpal-tr-resize wpal-atr-textarea'
                                                    value={preETC}
                                                    onChange={(e) => setPreETC(e.target.value)}
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        어린이 승객 정보
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preChildInfo
                                            ) : status == '1' ? (
                                                detailData?.preChildInfo
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='childinfo'
                                                    placeholder='이름/DOB/동반 성인 이름 또는 티켓번호'
                                                    value={preChildInfo}
                                                    onChange={(e) =>
                                                        setPreChildInfo(e.target.value)
                                                    }
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        유아 승객 정보
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preInfantInfo
                                            ) : status == '1' ? (
                                                detailData?.preInfantInfo
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='infantinfo'
                                                    placeholder='이름/DOB/동반 성인 이름 또는 티켓번호'
                                                    value={preInfantInfo}
                                                    onChange={(e) =>
                                                        setPreInfantInfo(e.target.value)
                                                    }
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>FOC</th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {status == '99' ? (
                                                detailData?.preFOC
                                            ) : status == '1' ? (
                                                detailData?.preFOC
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='foc'
                                                    value={preFOC}
                                                    onChange={(e) => setPreFOC(e.target.value)}
                                                    placeholder='이름'
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th
                                        rowSpan={4}
                                        className='wpal-atr-each-price-wrap wpal-atr-td-header table-line-b'
                                    >
                                        1인당 금액
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span className='wpal-atr-td-header table-line-b wpal-atr-each-price'>
                                                성인
                                            </span>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>판매가</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preAdultSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preAdultSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='adultprice'
                                                        value={parseInt(
                                                            preAdultSelling,
                                                        ).toLocaleString('ko-KR')}
                                                        onChange={(e) =>
                                                            setPreAdultSelling(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preAdultTax,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preAdultTax,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='adulttax'
                                                        value={parseInt(preAdultTax).toLocaleString(
                                                            'ko-KR',
                                                        )}
                                                        onChange={(e) =>
                                                            setPreAdultTax(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                {status == '99' ? (
                                                    detailData?.preAdultNum
                                                ) : status == '1' ? (
                                                    detailData?.preAdultNum
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='adultcount'
                                                        value={preAdultNum}
                                                        onChange={(e) =>
                                                            setPreAdultNum(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span className='wpal-atr-td-header table-line-b wpal-atr-each-price'>
                                                소아
                                            </span>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>판매가</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preChildSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preChildSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='childprice'
                                                        value={parseInt(
                                                            preChildSelling,
                                                        ).toLocaleString('ko-KR')}
                                                        onChange={(e) =>
                                                            setPreChildSelling(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preChildTax,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preChildTax,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='childtax'
                                                        value={parseInt(preChildTax).toLocaleString(
                                                            'ko-KR',
                                                        )}
                                                        onChange={(e) =>
                                                            setPreChildTax(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                {status == '99' ? (
                                                    detailData?.preChildNum
                                                ) : status == '1' ? (
                                                    detailData?.preChildNum
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='childcount'
                                                        value={preChildNum}
                                                        onChange={(e) =>
                                                            setPreChildNum(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span className='wpal-atr-td-header table-line-b wpal-atr-each-price'>
                                                유아
                                            </span>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>판매가</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preInfantSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preInfantSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='infantprice'
                                                        value={parseInt(
                                                            preInfantSelling,
                                                        ).toLocaleString('ko-KR')}
                                                        onChange={(e) =>
                                                            setPreInfantSelling(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preInfantTax,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preInfantTax,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='infanttax'
                                                        value={parseInt(
                                                            preInfantTax,
                                                        ).toLocaleString('ko-KR')}
                                                        onChange={(e) =>
                                                            setPreInfantTax(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                {status == '99' ? (
                                                    detailData?.preInfantNum
                                                ) : status == '1' ? (
                                                    detailData?.preInfantNum
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='infantcount'
                                                        value={preInfantNum}
                                                        onChange={(e) =>
                                                            setPreInfantNum(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span className='wpal-atr-td-header table-line-b wpal-atr-each-price'>
                                                FOC
                                            </span>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>판매가</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preFOCSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preFOCSelling,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='adultprice'
                                                        value={parseInt(
                                                            preFOCSelling,
                                                        ).toLocaleString('ko-KR')}
                                                        onChange={(e) =>
                                                            setPreFOCSelling(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                {status == '99' ? (
                                                    parseInt(
                                                        detailData?.preFOCTax ?? 0,
                                                    )?.toLocaleString('ko-KR')
                                                ) : status == '1' ? (
                                                    parseInt(
                                                        detailData?.preFOCTax ?? 0,
                                                    )?.toLocaleString('ko-KR')
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='adulttax'
                                                        value={parseInt(preFOCTax).toLocaleString(
                                                            'ko-KR',
                                                        )}
                                                        onChange={(e) =>
                                                            setPreFOCTax(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}

                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                {status == '99' ? (
                                                    detailData?.preFOCNum ?? 0
                                                ) : status == '1' ? (
                                                    detailData?.preFOCNum ?? 0
                                                ) : (
                                                    <input
                                                        type='text'
                                                        id='adultcount'
                                                        value={preFOCNum}
                                                        onChange={(e) =>
                                                            setPreFOCNum(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        TOTAL 입금액
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap wpal-display-wrap wpal-atr-totalprice'>
                                            {status == '99' ? (
                                                parseInt(detailData?.preTotal)?.toLocaleString(
                                                    'ko-KR',
                                                )
                                            ) : status == '1' ? (
                                                parseInt(detailData?.preTotal)?.toLocaleString(
                                                    'ko-KR',
                                                )
                                            ) : (
                                                <input
                                                    type='text'
                                                    id='totalprice'
                                                    value={parseInt(preTotal).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    disabled
                                                />
                                            )}

                                            <span className='wpal-atr-span'>원</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>결제 정보</h4>

                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>지불 수단</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData?.prePayment === 'cash'
                                                ? '현금 입금'
                                                : '카드 결제'}
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>입금액</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {parseInt(detailData?.preTotal)?.toLocaleString(
                                                'ko-KR',
                                            )}{' '}
                                            <span className='wpal-atr-span'>원</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>입금 계좌</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            외환은행 067-22-01441-1
                                            <br />
                                            (예금주: 락소홀딩스 주식회사)
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>입금일</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData?.preDepositDate ?? ''}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>처리 결과</h4>
                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>처리일시</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {moment(detailData?.regDate).format(
                                                'YYYY-MM-DD HH:mm',
                                            ) ?? ''}
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>상태</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData?.preStatus ?? ''}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        여행사 전달 사항
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            {detailData?.preBigo ?? ''}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='submitArea' style={{ display: 'flex', gap: '75px' }}>
                        {status == 99 ? (
                            <></>
                        ) : (
                            <input
                                class={`each-button`}
                                type='button'
                                value='수정하기'
                                onClick={() => requestUpdate()}
                            />
                        )}
                        {status == 99 ? (
                            <></>
                        ) : status == 1 ? (
                            <></>
                        ) : (
                            <input
                                class={`each-button`}
                                type='button'
                                value='취소요청'
                                onClick={() => requestCancel()}
                            />
                        )}
                        
                        {/* 개발전 요청 삭제 기능 */}
                        {/* {detailData?.preStatus == '취소확인' ? (
                            <input
                                class={`each-button`}
                                type='button'
                                value='요청삭제'
                                onClick={() => requestDelete()}
                            />
                        ) : (
                            <></>
                        )} */}
                    </div>
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default ATRdetail;
